module.exports = __webpack_public_path__ + "img/predatory-ambition.3ec06c4e.png";